import React, { useEffect, useRef, useState } from 'react';

function ProgressiveImage({ src, alt, style = {}, imgStyle = {}, placeholderSrc, className, loadingText = 'Loading image…' }) {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    setLoaded(false);
  }, [src, placeholderSrc]);

  useEffect(() => {
    const img = imgRef.current;
    if (img?.complete && img.naturalWidth > 0) {
      setLoaded(true);
    }
  }, [src]);

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        backgroundColor: 'transparent',
        ...style,
      }}
    >
      {placeholderSrc && (
        <img
          src={placeholderSrc}
          alt={alt}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(16px)',
            transform: 'scale(1.04)',
           transition: 'opacity 250ms ease',
           opacity: loaded ? 0 : 1,
           pointerEvents: 'none',
         }}
          aria-hidden="true"
        />
      )}

      {!loaded && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: placeholderSrc ? 'rgba(255,255,255,0.9)' : '#ffffff',
            transition: 'opacity 200ms ease',
            opacity: 1,
            pointerEvents: 'none',
          }}
        >
          <svg
            viewBox="0 0 50 50"
            style={{ width: 48, height: 48, display: 'block' }}
          >
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke="#000000"
              strokeWidth="2"
            />
            <path
              fill="none"
              stroke="#000000"
              strokeWidth="2"
              strokeLinecap="round"
              d="M45 25a20 20 0 0 1-20 20"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        </div>
      )}

      <img
        ref={imgRef}
        src={src}
        alt={alt}
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          transition: 'opacity 250ms ease',
          opacity: loaded ? 1 : 0,
          ...imgStyle,
        }}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        loading="lazy"
      />
    </div>
  );
}

export default ProgressiveImage;
